/* ============
 * order received
 * ============
 *
 */
import { mapGetters } from 'vuex';
import userWidgetsService from './../../../services/widgets';

export default {

  data() {
    return {
      number: 0,
      loaded: false,
    };
  },

  computed: {
    ...mapGetters({
      orderReceivedWidgets: 'orderReceivedWidgets',
    }),
  },

  watch: {
    orderReceivedWidgets(orderReceivedWidgets) {
      this.number = orderReceivedWidgets.items;
      this.loaded = true;
    },
  },

  methods: {
    initializeWidgets() {
      Promise.all([
        userWidgetsService.fetchOrderReceivedWidgets(),
      ]).then(() => {
        this.number = this.orderReceivedWidgets.items;
        this.loaded = true;
      });
    },
  },

  created() {
    this.initializeWidgets();
  },

};



// WEBPACK FOOTER //
// ./src/app/components/widgets/orderReceived/orderReceived.js